// Navigation
$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }
});

$(document).on('scroll', function () {
    $('.animate').not('.run').each(function () {
        if ($(this).offset().top < $(document).scrollTop() + window.innerHeight) $(this).addClass('run');
    })
}).trigger('scroll');

const bindClickable = () => {
    document.querySelectorAll(".clickable").forEach((card) => {
        const link = card.querySelector("a");

        if (link) {
            card.addEventListener("click", () => {
                link.click();
            });
            card.classList.add("ready");
        }
    });
};

$(document).ready(function () {
    bindClickable();

    if ($('.benefits-block').length) {
        watchBenefits();
    }

    if ($('.faq-component').length) {
        // Triggers each faq-list's faq folding twice to get each faq list to be closed initially
        $('.faq-list').each(function () {
            let $firstFAQ = $(this).find('.faq-item').first();
            $firstFAQ.trigger('click').trigger('click');
        });
    }

    if ($('.testimonials-list-container').length) {
        $('.testimonials-list-container').each(function () {
            watchTestimonials($(this))
        });
    }

    $(document).on('click', function (e) {
        if ($('body.menu-open').length) {
            let $target = $('header');

            if (!$target.is(e.target) && $target.has(e.target).length === 0) {
                if ($('body').hasClass('menu-open')) {
                    $('body').removeClass('menu-open');
                }
                if ($('.nav-container').hasClass('menu-active')) {
                    $('.nav-container').removeClass('menu-active');
                }
            }
        }
    });

    if ($('.faq-item').length) {
        watchFAQs();
    }

    $('h6[data-id="privacy_policy"]').html(
        'By submitting you agree to our friendly <a href="/privacy-policy" target="_blank">privacy policy</a>.'
    );

    if ($('.glide.staff-carousel').length) {
        $('.glide.staff-carousel').each(function () {
            initStaffCarousel($(this));
        })
    }

    if ($('.category-link').length) {
        watchCategories();
    }

    if ($('.header-container .search-btn').length) {
        watchSearch();
    }

    if ($('#SearchResults').length) {
        $('#SearchResults').children('.first').find('a').focus();
    }
});

function watchSearch() {
    let $targetBtn = $('.header-container').children('.search-btn:not(input)');
    let $targetEle = $('.form-container.header-form-container');
    let $hiddenEle = $targetEle.children('#SearchForm_SearchForm');
    let $phoneLink = $('.header-container').children('.phone-link-container');

    $targetEle.hide();
    $hiddenEle.hide();

    $targetBtn.on('click', function (event) {
        event.preventDefault()
        $targetEle.toggleClass('active');

        if (!$targetEle.hasClass('active')) {
            if ($targetBtn.attr('aria-expanded') === 'true') {
                $targetBtn.attr('aria-expanded', 'false');
            }
            $hiddenEle.hide();
            $targetEle.height(0).height(125);
            $phoneLink.toggleClass('active');
            window.setTimeout(function () {
                $targetEle.hide().height('');
                $targetEle.css('position', 'unset');
                $targetEle.css('z-index', 'unset');
            }, 250);
            $hiddenEle.hide();
            let height = $targetEle.height()
            $targetEle.height(height).height(0)
            window.setTimeout(function () {
                $targetEle.hide().height('');
            }, 250);
        } else {
            if ($targetBtn.attr('aria-expanded') === 'false') {
                $targetBtn.attr('aria-expanded', 'true');
            }
            $targetEle.show()
            $targetEle.css('position', 'relative');
            $targetEle.css('z-index', '1010');
            window.setTimeout(function () {
                $targetEle.height(0).height(125);
                $phoneLink.toggleClass('active');
            }, 250);
            window.setTimeout(function () {
                $hiddenEle.show()
                $('#SearchFormExtension_SearchForm_Search').focus();
            }, 450);
        }
    });
}

function watchCategories() {
    let $Categories =  $('.category-link');
    $Categories.each(function () {
        $(this).on('click', function (e) {
            let $CatID = $(this).data('category');
            let $BlogListContainer = $(this).closest('.blogs-content-container');
            let $BlogsLists = $BlogListContainer.find('.blogs-preview-block__grid');

            $Categories.each(function () {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                }

                if (!$(this).hasClass('inactive')) {
                    $(this).addClass('inactive');
                }
            })

            if (!($(this).hasClass('active'))) {
                $(this).addClass('active');
            }

            $BlogsLists.each(function () {
                if ($(this).data('cat-id') === $CatID) {
                    if ($(this).hasClass('inactive')) {
                        $(this).removeClass('inactive');
                    }

                    if (!($(this).hasClass('active'))) {
                        $(this).addClass('active');
                    }
                } else {
                    if ($(this).hasClass('active')) {
                        $(this).removeClass('active');
                    }

                    if (!$(this).hasClass('inactive')) {
                        $(this).addClass('inactive');
                    }
                }
            })
        });
    });
}

function initStaffCarousel($glide) {
    let $glideID = $glide.attr('id');
    let $glideEle = $(`#${$glideID}`)[0];

    let $thisGlide = new Glide($glideEle, {
        type: "carousel",
        perView: 3,
        keyboard: true,
        gap: 32,
        breakpoints: {
            1024: { perView: 2 },
            600: { perView: 1 }
        }
    }).mount();

    window.setTimeout(function () {
        $thisGlide.update();
    }, 1250)
}

function watchFAQs() {
    $('.faq-list.default .faq-item').each(function () {
        let $item = $(this);
        let $content = $item.find('.faq-bottom');

        // Make entire FAQ item focusable for keyboard access
        $item.attr('tabindex', '0');

        $item.on('click keydown', function (e) {
            if (e.type === 'click' || e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();

                let isActive = $item.hasClass('open');

                // Close others
                $('.faq-list.default .faq-item').not($item).each(function () {
                    let $other = $(this);
                    let $otherContent = $other.find('.faq-bottom');

                    $other.removeClass('open');
                    $otherContent.slideUp(300, function () {
                        $otherContent.addClass('d-none');
                    });
                });

                if (!isActive) {
                    // Open this one
                    $item.addClass('open');
                    $content.removeClass('d-none').slideDown(300);
                } else {
                    // Close this one
                    $item.removeClass('open');
                    $content.slideUp(300, function () {
                        $content.addClass('d-none');
                    });
                }
            }
        });

        // Prevent toggling when clicking inner links/buttons
        $item.find('a, button').on('click', function (e) {
            e.stopPropagation();
        });
    });
}

function watchTestimonials($glide) {
    if (!$glide || !$glide.length) return;

    let $glide1 = $glide.children('.testimonials-glide-container');
    if (!$glide1.length) return;

    let $glideID = $glide1.attr('id');
    if (!$glideID) return;

    let $glideEle = document.getElementById($glideID);
    if (!$glideEle) return;

    let $targetCog = $glide;

    let $mainGlide = new Glide($glideEle, {
        type: "carousel",
        keyboard: true,
        gap: 32,
        autoplay: 12000,
        perView: 2,
        breakpoints: {
            768: {
                perView: 1
            }
        }
    });

    // Mount glide instance
    setTimeout(function () {
        $mainGlide.mount();
    }, 1000);

    // Update + show
    setTimeout(function () {
        $mainGlide.update();
        $targetCog.removeClass('inactive');
    }, 1250);
}

function watchBenefits() {
    let $SecondStart = 96;
    let $Benefits = $('.benefit-tile');

    $.each($Benefits, function (i, ele) {
        if ($(this).hasClass('benefit-set-1')) {
            $SecondStart += 1;

            $(this).css('grid-area', String.fromCharCode($(this).data('pos') + 96))
        } else if ($(this).hasClass('benefit-set-2')) {
            $(this).css('grid-area', String.fromCharCode($(this).data('pos') + $SecondStart))
        }
    });
}
